import React from "react";
import { getSiteLogo } from "@/lib/siteHosts";

const SiteLogo = ({ className, testId }) => {
  const { src, alt } = getSiteLogo();
  return <img src={src} alt={alt} className={className} data-testid={testId} />;
};

export default SiteLogo;
